import FLAG from 'config/flag.singleton';
import ATS from 'constants/core/actionTypeSuffix.const';
import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('requestStatusReducer');

const OLD_SUFFIX_INIT = '_REQUEST';
const OLD_SUFFIX_PASS = '_SUCCESS';
const OLD_SUFFIX_FAIL = '_FAILURE';
const OLD_SUFFIX_DONE = '_DONE';

const RE_SUFFIX = new RegExp(
  `(${[
    OLD_SUFFIX_INIT,
    OLD_SUFFIX_PASS,
    OLD_SUFFIX_FAIL,
    OLD_SUFFIX_DONE,
    ATS.init, // NEW_SUFFIX_INIT
    ATS.pass, // NEW_SUFFIX_PASS
    ATS.fail, // NEW_SUFFIX_FAIL
    ATS.done, // NEW_SUFFIX_DONE
  ].join('|')})$`,
);

// NOTE: a hacky and very sloppy way of determining when an old v1 request started and finished
const requestStatusReducer = (state, action) => {
  const { type } = asObject(action);
  const oldState = asObject(state);

  if (!type) return oldState;

  const trimmed = fromAnyToTrimmed(type);

  const is = {
    init: trimmed.endsWith(OLD_SUFFIX_INIT) || trimmed.endsWith(ATS.init),
    pass: trimmed.endsWith(OLD_SUFFIX_PASS) || trimmed.endsWith(ATS.pass),
    fail: trimmed.endsWith(OLD_SUFFIX_FAIL) || trimmed.endsWith(ATS.fail),
    done: trimmed.endsWith(OLD_SUFFIX_DONE) || trimmed.endsWith(ATS.done),
  };

  if (!is.init && !is.pass && !is.fail && !is.done) {
    // not an action we're interested in, ignore it
    return oldState;
  }

  const prefix = trimmed.replace(RE_SUFFIX, S.empty);
  const isLoading = is.init && !is.pass && !is.fail && !is.done;

  if (oldState[prefix] === isLoading) {
    // if there isn't an actual change, keep the same state object
    return oldState;
  }

  if (FLAG.loggerSpam) L.debug('()', oldState[prefix], S.arrowW, isLoading, S.arrowW, prefix, S.arrowW, is);

  return { ...oldState, [prefix]: isLoading };
};

// noinspection JSUnusedGlobalSymbols
export default requestStatusReducer;
